import { chunk } from 'lodash'
import { type OpalApiResponseDocument } from '../../schema'
import { type WorkflowsKey } from './queryHelpers'
import { readWorkflows } from './read'

export type MomentWorkflowsDocument = Pick<
  OpalApiResponseDocument<'ReadWorkflowsV2', 200>,
  'data' | 'included'
>

export const momentWorkflowsIdentifiers = (
  workspaceUuid: string,
  legacyMomentIds: number[]
): WorkflowsKey => ({
  workspaceUuid,
  queryParams: { filter: { 'context.moment_id': legacyMomentIds } },
})

/**
 * Reads the workflows of the given moments, with their contexts, in requests
 * of up to 250 moments each.
 */
export const readMomentWorkflows = async (
  legacyMomentIds: number[]
): Promise<MomentWorkflowsDocument> => {
  const results = await Promise.all(
    chunk(legacyMomentIds, 250).map((chunkedIds) =>
      readWorkflows({
        query: {
          include: ['context'],
          page: { limit: 250 },
          expose: { workflow: { meta: null } },
          filter: { ['context.moment_id']: chunkedIds },
        },
      })
    )
  )

  const included = results.flatMap((result) => result.included || [])

  return {
    data: results.flatMap((document) => document.data),
    included,
  }
}
